import script from "./result.vue?vue&type=script&lang=ts&setup=true"
export * from "./result.vue?vue&type=script&lang=ts&setup=true"

import "./result.vue?vue&type=style&index=0&id=1c74a90b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c74a90b"]])

export default __exports__